import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

export default {
  async searchTechBusinesses({
    commit,
    state,
    dispatch
  }, search) {
    let data = await startLoading(http.get(`UserQuery/SearchTechnicians/?search=${search}`))
    let _techBusinesses = []
    for (let tech of data) {
      let techBusiness = tech.name
      _techBusinesses.push(techBusiness)
      console.log(_techBusinesses, techBusiness, search)
    }
    commit(types.SET_TECH_BUSINESSES, _techBusinesses)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/config-settings/actions.js